import React from "react";
import { connect } from "react-redux";
import { authConstants } from '../../_constants';
import _ from 'lodash';

import { identityService } from '../../services'

class HoldingPage extends React.Component {
    constructor(props){
        super(props);
        this.login = this.login.bind(this);
    }

    login(){
        let tenant = _.get(this.props, 'tenant', '');

        if (!tenant) tenant = localStorage[authConstants.LOCAL_TENANT_KEY];

        identityService.redirectSignIn(tenant);
    }

    render() {
        return  <div className="App-header">
            <h2>Redirecting...</h2>
        </div>
    }

    componentDidMount(){
        // If we already have an auth error in URL, don't immediately try again (prevents loops)
        if (window.location.search.includes('error=')) {
            console.warn('[HoldingPage] Detected auth error in URL; not auto-triggering login');
            return;
        }
        this.login();
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tenant: state.auth.tenant
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

const connectedHoldingPage = connect(mapStateToProps, mapDispatchToProps)(HoldingPage);
export { connectedHoldingPage as HoldingPage };
